import { ICowsList } from 'models/ICattlesData'
import { COLORS } from 'styles/colors'

type LactationStage =
	| 'начало лактации'
	| 'пик лактации'
	| 'середина лактации'
	| 'завершение лактации'
	| 'сух 1'
	| 'сух 2'

type FatnessStageCategory = 'normal' | 'deviation' | 'critical'

const SCORE_GROUPS: Record<
	LactationStage,
	Record<FatnessStageCategory, number[]>
> = {
	'начало лактации': {
		normal: [2.75, 3.0, 3.25, 3.5, 3.75],
		deviation: [1.75, 2.0, 2.25, 2.5, 4.0, 4.25],
		critical: [1.0, 1.25, 1.5, 4.5, 4.75, 5.0],
	},
	'пик лактации': {
		normal: [2.5, 2.75, 3.0, 3.25, 3.5, 3.75],
		deviation: [1.75, 2.0, 2.25, 4.0, 4.25],
		critical: [1.0, 1.25, 1.5, 4.5, 4.75, 5.0],
	},
	'середина лактации': {
		normal: [2.5, 2.75, 3.0, 3.25],
		deviation: [1.75, 2.0, 2.25, 3.5, 3.75, 4.0, 4.25],
		critical: [1.0, 1.25, 1.5, 4.5, 4.75, 5.0],
	},
	'завершение лактации': {
		normal: [2.5, 2.75, 3.0, 3.25, 3.5, 3.75],
		deviation: [1.75, 2.0, 2.25, 3.5, 3.75, 4.0, 4.25],
		critical: [1.0, 1.25, 1.5, 4.5, 4.75, 5.0],
	},
	'сух 1': {
		normal: [3.25, 3.5, 3.75],
		deviation: [1.75, 2.0, 2.25, 2.5, 2.75, 3.0, 4.0, 4.25],
		critical: [1.0, 1.25, 1.5, 4.5, 4.75, 5.0],
	},
	'сух 2': {
		normal: [3.0, 3.25, 3.5, 3.75],
		deviation: [1.75, 2.0, 2.25, 2.5, 2.75, 4.0, 4.25],
		critical: [1.0, 1.25, 1.5, 4.5, 4.75, 5.0],
	},
}

const SCORE_EPSILON = 0.001

const isSameScore = (left: number, right: number) =>
	Math.abs(left - right) < SCORE_EPSILON

const getLactationStage = (lactationDay: number): LactationStage | null => {
	if (lactationDay >= 0 && lactationDay <= 30) return 'начало лактации'
	if (lactationDay >= 31 && lactationDay <= 100) return 'пик лактации'
	if (lactationDay >= 101 && lactationDay <= 200) return 'середина лактации'
	if (lactationDay >= 201 && lactationDay <= 305) return 'завершение лактации'
	if (lactationDay >= 306 && lactationDay <= 343) return 'сух 1'
	if (lactationDay >= 344 && lactationDay <= 365) return 'сух 2'
	return null
}

const getCategoryByTable = (
	fatness: number | null | undefined,
	lactationDay: number | null | undefined,
): FatnessStageCategory | null => {
	if (typeof fatness !== 'number' || typeof lactationDay !== 'number')
		return null
	const stage = getLactationStage(lactationDay)
	if (!stage) return null
	const stageConfig = SCORE_GROUPS[stage]
	if (stageConfig.critical.some(value => isSameScore(value, fatness))) {
		return 'critical'
	}
	if (stageConfig.deviation.some(value => isSameScore(value, fatness))) {
		return 'deviation'
	}
	if (stageConfig.normal.some(value => isSameScore(value, fatness))) {
		return 'normal'
	}
	return null
}

export const getFatnessColorByTable = (
	fatness: number | null | undefined,
	lactationDay: number | null | undefined,
	status?: ICowsList['fatness_status'],
) => {
	const tableCategory = getCategoryByTable(fatness, lactationDay)
	if (tableCategory === 'critical') return COLORS.error
	if (tableCategory === 'deviation') return COLORS.health
	if (tableCategory === 'normal') return COLORS.black

	if (status === 'critical') return COLORS.error
	return COLORS.black
}
